import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import axios from "axios";
import SuccessMessage from "../components/SuccessMessage";
import { FaArrowRightLong } from "react-icons/fa6";

function Billing() {
    const [cartItems, setCartItems] = useState([]);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const customerType = localStorage.getItem("CustomerType");
    const Ledcode = localStorage.getItem("Ledcode");
    const LedName = localStorage.getItem("LedName");
    // const navigate = useNavigate();

    // console.log("customerType:",customerType);

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("productData")) || [];
        setCartItems(storedData);
    }, []);

    const getPriceBasedOnCustomerType = (item) => {
        switch (customerType) {
            case "CUSTOMER":
                return item.mop;
            case "DEALER":
                return item.dp;
            case "AGENT":
                return item.ap;
            case "JS_MANAGER":
                return item.mop;
            case "JS_EMPLOYEE":
                return item.mop;
            case "TK_MANAGER":
                return item.mop;
            case "TK_EMPLOYEE":
                return item.mop;
            default:
                return item.mrp; // Default to MOP if customerType is unknown
        }
    };

    const currentDate = new Date().toLocaleDateString("en-GB").split("/").reverse().join("-");
    const mobile = "";

    const total = cartItems
        .reduce((total, item) => total + parseFloat(getPriceBasedOnCustomerType(item)) * parseFloat(item.quantity), 0)
        .toFixed(2);

    const cDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });

    const handleSubmit = async () => {
        if (cartItems.length === 0) {
            alert("Cart is empty");
            return;
        }

        const items = cartItems
            .map(
                (item) =>
                    `{\\"id\\":${item.id},\\"name\\":\\"${item.itemName}\\",\\"model\\":\\"${
                        item.selectedModel
                    }\\",\\"dp\\":${getPriceBasedOnCustomerType(item).toFixed(2)},\\"mrp\\":${(
                        parseFloat(getPriceBasedOnCustomerType(item)) * parseInt(item.quantity)
                    ).toFixed(2)},\\"quantity\\":${item.quantity}}`
            )
            .join(",");

        const order = `{"date":"${currentDate}","id":"${Ledcode}","contact":"${mobile}","items":"[${items}]"}`;
        console.log("order:", order);

        try {
            const response = await axios.post(`${apiBaseUrl}/orderAdd/JAPAN_ACCESORIES`, JSON.parse(order), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Order response:", response.data);
            setOrderSuccess(true);
            localStorage.removeItem("productData");

            let tableText = `Date: ${cDate}\nCustomer Name: ${LedName}\n\nCheckout my cart items:\n\n`;

            // Prepare the WhatsApp message
            const message = cartItems
                .map(
                    (item) =>
                        `Product: ${item.itemName}\nModel: ${item.selectedModel}\nPrice: ${getPriceBasedOnCustomerType(
                            item
                        ).toFixed(2)}\nQuantity: ${item.quantity}`
                )
                .join("\n\n");

            tableText += message + "\n";

            const totalAmountText = `\n\nTotal Amount: ${total}`;

            tableText += totalAmountText + "\n";

            const encodedMessage = encodeURIComponent(tableText);
            window.location.href = `whatsapp://send?text=${encodedMessage}`;
        } catch (error) {
            console.error("Error placing order:", error);
            // Handle error, e.g., show error message
        }
    };

    // const address = async () => {
    //     navigate("/address");
    // };

    return (
        <div className="min-h-screen flex flex-col  flex-1 pb-5">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>

            {orderSuccess && <SuccessMessage message="Order placed successfully!" total={total} />}

            <div className="w-full lg:px-[7%] px-[2%] flex flex-col  mt-5">
                <div className="w-full flex lg:flex-row flex-col gap-8 mt-8">
                    <div className="lg:w-[70%] w-full h-auto flex flex-col  rounded-md  ">
                        {/* Title */}
                        <span className="font-semibold w-full text-xl font-display px-4">Billing Information</span>
                        <div className="grid grid-cols-4 md:grid-cols-4 gap-2 p-4">
                            {/* Row 1 */}
                            <label for="" className="hidden md:block col-span-2 font-medium">
                                User
                            </label>
                            <label for="" className="hidden md:block col-span-2 font-medium">
                                Company
                            </label>
                            <input
                                name="firstName"
                                placeholder="First Name"
                                className="col-span-2 md:col-span-1 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="lastName"
                                placeholder="Last Name"
                                className="col-span-2 md:col-span-1 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="company"
                                placeholder="Company Name"
                                className="col-span-4 md:col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />

                            {/* Row 2 */}
                            <label for="" className="hidden md:block col-span-2 font-medium">
                                Address
                            </label>
                            <input
                                name="street"
                                placeholder="Street Address"
                                className="col-span-4 border border-[#b8b8b9] p-2 rounded w-full"
                            />

                            {/* Row 3 */}
                            <label for="" className="hidden md:block col-span-1 font-medium">
                                Country
                            </label>
                            <label for="" className="hidden md:block col-span-1 font-medium">
                                State
                            </label>
                            <label for="" className="hidden md:block col-span-1 font-medium">
                                City
                            </label>
                            <label for="" className="hidden md:block col-span-1 font-medium">
                                ZIP Code
                            </label>

                            <input
                                name="country"
                                placeholder="Country"
                                className="md:col-span-1 col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="state"
                                placeholder="State"
                                className="md:col-span-1 col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="city"
                                placeholder="City"
                                className="md:col-span-1 col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="zip"
                                placeholder="ZIP Code"
                                className="md:col-span-1 col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />

                            {/* Row 4 */}
                            <label for="" className="hidden md:block col-span-2 font-medium">
                                Email
                            </label>
                            <label for="" className="hidden md:block col-span-2 font-medium">
                                Phone
                            </label>
                            <input
                                name="email"
                                placeholder="Email"
                                className="col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />
                            <input
                                name="phone"
                                placeholder="Phone"
                                className="col-span-2 border border-[#b8b8b9] p-2 rounded w-full"
                            />

                            {/* Row 5 */}
                            <label for="" className="font-medium">
                                Additional&nbsp;Information
                            </label>
                            <textarea
                                name="notes"
                                placeholder="Notes about your order / Special notes for delivery"
                                rows={3}
                                className="col-span-4 border border-[#b8b8b9] p-2 rounded w-full resize-none"
                            />
                        </div>
                    </div>

                    <div className="w-full lg:w-[30%]">
                        <div className="w-full lg:w-[100%] flex flex-col  lg:mb-0 sticky top-20">
                            <div className="border-2 rounded-md border-[#EAEAEC] pb-4 bg-white shadow-md">
                                <div className="w-full h-[18%] bg-[#FFF6F4] px-3 py-3 flex justify-between items-center text-base font-[600] font-[display]">
                                    <span className="text-base font-[600] font-display">Price Details</span>
                                </div>

                                <div className="w-full h-[82%]   flex  flex-col px-3 gap-2">
                                    <ul className=" mt-5" />
                                    <div className="flex flex-col gap-5 w-full">
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">
                                                Sub Total ({cartItems.length})
                                            </span>
                                            <span className="text-base font-[600] font-display">₹{total}</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Shipping</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Discount</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Tax</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                    </div>
                                    <ul className="border-2 border-black mt-5 text-[#F0F0F0]" />
                                    <div className="w-full flex justify-between">
                                        <span className="text-base font-[600] font-display">Total Amount</span>
                                        <span className="text-base font-[600] font-display">
                                            ₹
                                            {cartItems
                                                .reduce(
                                                    (total, item) =>
                                                        total +
                                                        parseFloat(getPriceBasedOnCustomerType(item)) *
                                                            parseFloat(item.quantity),
                                                    0
                                                )
                                                .toFixed(2)}
                                        </span>
                                    </div>
                                    {/* <ul className="border-b-2 border-black border-dashed " /> */}
                                </div>
                            </div>

                            <div className="p-4 mt-9 rounded-md bg-[#EAEAEC]">
                                <button
                                    className="h-[50px] w-full bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer"
                                    onClick={handleSubmit}
                                >
                                    PROCEED TO CHECKOUT
                                    <FaArrowRightLong className="ml-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Billing;
